import { lt } from '@mews/framework';
import { Button, IconName } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { prepareSettlementRuleValues } from '../utils';
import { useCreateSettlementRule } from '../queries';
import { useCreatePaymentPolicyDialogForm } from './useCreatePaymentPolicyDialogForm';
import { FormValues } from './schema';

export const CreateSettlementRuleDialog = ({ buttonTextKey }: { buttonTextKey: Mews.TextKey }) => {
    const { mutateAsync } = useCreateSettlementRule();
    const handleSubmit = async (formValues: FormValues) => mutateAsync(prepareSettlementRuleValues(formValues));

    const [renderDialog, toggleDialog] = useCreatePaymentPolicyDialogForm({ handleSubmit });

    return (
        <>
            <Button
                icon={IconName.Add}
                onClick={toggleDialog}
                size="small"
                data-test-id={DataTestId.NewPaymentPolicy}
                type="submit"
            >
                {lt(buttonTextKey)}
            </Button>
            {renderDialog()}
        </>
    );
};
